import React from 'react'

export default function Skeleton2() {
    return (
        <div className="skeleton-cards-row">
            {[...Array(5)].map((_, i) => (
                <div key={i} className="skeleton-game-card skeleton">
                    <div className="skeleton-game-thumb"></div>
                    <div className="skeleton-game-button"></div>
                </div>
            ))}
        </div>

    )
}
